import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { DateInputMobile } from '../DateInputMobile';
import { DateInputDesktop } from '../DateInputDesktop';
export var DateInput = /*#__PURE__*/React.forwardRef(function DateInput(props, ref) {
  var deviceType = useDeviceType();
  if (deviceType === 'phone') {
    return /*#__PURE__*/React.createElement(DateInputMobile, _extends({}, props, {
      ref: ref
    }));
  }
  return /*#__PURE__*/React.createElement(DateInputDesktop, _extends({}, props, {
    ref: ref
  }));
});